<template>
  <div class="list-scroll">
    <div class="plan-list">
      <div
        class="plan-item"
        v-for="(item, index) in data"
        :key="index"
        @click="bindClick(item)"
      >
        <div class="mask" v-if="item.appointment_state == 0"></div>
        <div class="index" v-if="data.length > 1"
          >{{ index + 1 }}/{{ data.length }}</div
        >
        <div class="title">3日营养师1v1饮食指导</div>
        <div class="time">{{ item.startEnedTime }}</div>
        <div class="btn"
          ><span>{{ item.appointment_state | filterText }}</span
          ><span class="iconfont icon-you"></span
        ></div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    data: {
      type: Array,
      default: () => []
    }
  },
  filters: {
    filterText(state) {
      let obj = {
        '-1': '立即激活',
        0: '待激活',
        1: '待开班',
        2: '生效中',
        3: '已结束'
      }
      return obj[state]
    }
  },
  data() {
    return {}
  },
  methods: {
    bindClick(item) {
      switch (item.appointment_state) {
        case -1:
          this.$router.push({
            path: '/betterwe/reserve',
            query: {
              vid: this.$parent.vipInfo.id,
              type: this.$parent.vipInfo.type_id
            }
          })
          break
        case 1:
          this.$emit('click', item)
          break
        case 2:
          this.jumpCamp()
          break
        case 3:
          this.jumpCamp()
          break
      }
    },
    jumpCamp() {
      if (this.$http._isApp()) {
        this.$betterwe.onAppPageUrlRoute('/home?pageTag=1')
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.list-scroll {
  padding: 0px 14px;
  overflow-y: scroll;

  .plan-list {
    display: inline-flex;
    align-items: center;

    .plan-item {
      position: relative;
      width: 283px;
      padding: 16px;
      box-sizing: border-box;
      border-radius: 8px;
      background-image: url('https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/1aefb4ad8b2e82af79de588ea0620e39.png');
      background-repeat: no-repeat;
      background-size: contain;
      margin-right: 10px;

      .mask {
        background-color: rgba(255, 255, 255, 0.2);
        position: absolute;
        width: 100%;
        height: 100%;
        left: 0;
        top: 0;
        z-index: 1;
      }

      .index {
        text-align: center;
        width: 43px;
        height: 16px;
        background: linear-gradient(
          90deg,
          rgba(255, 255, 255, 0.8) 0%,
          rgba(255, 255, 255, 0) 100%
        );
        border-radius: 100px 0px 0px 100px;
        position: absolute;
        top: 10px;
        right: 0;
        font-size: 11px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 600;
        color: rgba(0, 0, 0, 0.4);
        line-height: 16px;
      }

      .title {
        margin-top: 24px;
        font-size: 14px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 600;
        color: rgba(0, 0, 0, 0.8);
        line-height: 24px;
      }

      .time {
        font-size: 12px;
        font-family: PingFangSC-Regular, PingFang SC;
        color: rgba(0, 0, 0, 0.6);
        line-height: 14px;
        margin-top: 16px;
      }

      .btn {
        position: absolute;
        top: 37px;
        right: 16px;
        height: 30px;
        background: linear-gradient(90deg, #9490ee 0%, #776fe0 100%);
        border-radius: 15px;
        padding: 0px 6px 0px 10px;
        font-size: 14px;
        font-family: AlibabaPuHuiTi-Medium, AlibabaPuHuiTi;
        font-weight: 600;
        color: #ffffff;
        display: flex;
        align-items: center;

        .iconfont {
          margin-left: 2px;
        }
      }

      .btn-disabled {
        background: linear-gradient(90deg, #babbc5 0%, #9fa0a8 100%);
      }
    }

    .plan-item:last-child {
      margin-right: 0;
    }
  }
}
</style>
